export default __webpack_public_path__ + "static/media/2.77354ce4.jpg";